import { render, staticRenderFns } from "./SelectOrder.vue?vue&type=template&id=37ce2056&scoped=true&"
import script from "./SelectOrder.vue?vue&type=script&lang=js&"
export * from "./SelectOrder.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrder.vue?vue&type=style&index=0&id=37ce2056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce2056",
  null
  
)

export default component.exports